var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"kpi2"}},[_c('div',{staticClass:"box"},[_c('div',{staticStyle:{"height":"100%"},attrs:{"id":"chartkpi2"}})])])}]

export { render, staticRenderFns }